/*
 * @Description:
 * @Author: zhanghao
 * @Date: 2025-03-19 14:36:04
 * @LastEditTime: 2025-03-20 15:32:42
 * @LastEditors: zhanghao
 */
export function parseJson<T>(data: string, defaultData: any = {}) {
  if (data === null) return defaultData as T

  try {
    return JSON.parse(data) as T
  } catch (error) {
    // console.log("🚀 ~ parseJson ~ error:", error);
  }

  return defaultData as T
}

// search参数转换
export const requestParams: any = (url: string) => {
  const params = url.split('?')[1].split('&')
  const obj: any = {}
  params.map(v => (obj[v.split('=')[0]] = v.split('=')[1]))
  return obj
}
export const make999Plus: any = (num: number | string) => {
  try {
    if (Number(num) > 999) {
      return `999+`
    } else {
      return num
    }
  } catch (error) {
    return num
  }
 
}
